import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { handlePost, handleDateChangeEvent } from '../../../../utils/AxiosUtil';

class ActivateEmployee extends Component {

  state = {
    date: new Date()
  }

  handleSubmit = async (event) => {
    event.persist()
    event.preventDefault();
    const requestObject = {
      "privateId": this.props.row.privateId,
      "date": this.state.date,
    };
    handlePost(this.props.path, requestObject, this);
  };

  handleSuccess = (res) => {
    this.props.refresh();
    this.props.close();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {console.log(this.props)}
        <div className='dialog-content'>
          {this.props.comp}
        </div>
        {this.props.row.employee.type === "FULL_TIME" &&
          <div className='input-group-3'>
            {this.props.inactivate ?

              <ErrorAwareDatePicker
                name="date"
                label="Jogviszony vége"
                errors={this.state.errors}
                value={this.state.date}
                onChange={(e) => handleDateChangeEvent(e, "date", this)}
              />
              :
              <ErrorAwareDatePicker
                name="date"
                label="Jogviszony kezdete"
                errors={this.state.errors}
                value={this.state.date}
                onChange={e => handleDateChangeEvent(e, "date", this)} />
            }
          </div>}
        <h3>
          Biztos, hogy {this.props.inactivate ? "inaktiválni" : "aktiválni"} szeretnéd?</h3>
        <div className="form-actions">
          <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
            Mégse
          </Button>
          <Button className="btn-submit" variant="contained" color="primary" type="submit">
            Igen
          </Button>
        </div>
      </form>

    )
  }
}

export default withSnackbar(ActivateEmployee);
